import { defaultIconProps, IconProps } from './IconProps';

export const IconSortDesc: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 16.6666V3.33331M10 3.33331L5 8.33331M10 3.33331L15 8.33331"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconSortDesc.defaultProps = defaultIconProps;
